export default "__VITE_ASSET__e31faf4a__"